export const tripState = {
    date: null
};
export const tripGetters = {};
export const tripMutations = {
    tripDate(state, date){
        state.trips.date = date;
    }
};
